import React, { Component } from 'react';
import ActionBar from '../../ActionBar';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { get } from 'lodash';
import { suppliesFieldChange } from 'redux/ducks/Post/Locations/actions';
import { saveAsDraft } from 'redux/ducks/Post/actions';
import { AVAILABLE_EQUIPMENTS, trackMixpanelPageView } from 'helpers/post';
import ConfirmationModal from 'components/V2/ConfirmationModal';
import ToolTip from 'scenes/V2/ToolTip';
import CustomCheckBox from 'components/V2/CustomInputs/CustomCheckBox';
import ExpandableSection from 'components/ExpandableSection';

class Supplies extends Component {
  constructor(props) {
    super(props);
    props.initialize('Supplies');

    const groupedEquipments = AVAILABLE_EQUIPMENTS.reduce((acc, equipment) => {
      const section = equipment.section;
      if (!acc[section]) acc[section] = [];
      acc[section].push(equipment);
      return acc;
    }, {});

    const recommendedSection = Object.keys(groupedEquipments).find(
      (section) => section === 'Recommended'
    );

    const defaultOpenSection = recommendedSection || Object.keys(groupedEquipments)[0];

    this.state = { isModalOpen: false, openSections: { [defaultOpenSection]: true } };
  }
  toggle = () => this.setState({ isModalOpen: !this.state.isModalOpen });

  componentDidMount() {
    if (!this.props.editMode)
      trackMixpanelPageView('create-event/details/supplies', this.props.user);
    
    const groupedEquipments = AVAILABLE_EQUIPMENTS.reduce((acc, equipment) => {
      const section = equipment.section;
      if (!acc[section]) acc[section] = [];
      acc[section].push(equipment);
      return acc;
    }, {});

    const firstSection = Object.keys(groupedEquipments)[0];
    this.setState({ openSections: { [firstSection]: true } });
  }

  toggleSection = (sectionName) => {
    this.setState((prevState) => ({
      openSections: {
        ...prevState.openSections,
        [sectionName]: !prevState.openSections[sectionName],
      },
    }));
  };


  hasEquipment = (value) => {
    const { supplies } = this.props.shiftLocation;
    const equipments = supplies.equipments || [];

    return equipments.some((eq) => eq === value);
  };

  toggleEquipment = (eq) => (e) => {
    const { locationIdx } = this.props;
    const { equipments } = this.props.shiftLocation.supplies;
    const newEquipment = this.hasEquipment(eq)
      ? equipments.filter((e) => e !== eq)
      : [...equipments, eq];

    this.props.onSuppliesChange(locationIdx, 'equipments', newEquipment);
  };

  onChangeOtherEquipments = (e) => {
    const { locationIdx } = this.props;
    const { value } = e.target;
    const [, ...equipments] = this.props.shiftLocation.supplies.equipments;

    this.props.onSuppliesChange(locationIdx, 'equipments', [value, ...equipments]);
  };

  onSaveAndContinue = () => {
    const { equipments } = this.props.shiftLocation.supplies;
    if (equipments.length === 1 && equipments[0] === '' && !this.state.isModalOpen) {
      this.toggle();
      return;
    }

    const { baseUrl, post } = this.props;
    const callback = () => {
      this.props.history.push(`${baseUrl}/details/details`);
    };

    if (!this.props.authenticated) {
      callback();
      return;
    }

    this.props.saveAsDraft(post, callback);
  };

  onSaveModal = () => {
    this.toggle();
    this.onSaveAndContinue();
  };

  computeBackTo = () => {
    const { baseUrl, editMode } = this.props;
    if (editMode) return `${baseUrl}/rate`;
    return `${baseUrl}/schedule-summary`;
  };

  handleExpandableClick = (sectionName) => (e) => {
  const clickedInsidePanelTop = e.target.closest('.panel-top');
    if (clickedInsidePanelTop) {
      this.toggleSection(sectionName);
    }
  };

  render() {
    const { supplies } = this.props.shiftLocation;
    const groupedEquipments = AVAILABLE_EQUIPMENTS.reduce((acc, equipment) => {
      const section = equipment.section;
      if (!acc[section]) acc[section] = [];
      acc[section].push(equipment);
      return acc;
    }, {});

    return (
      <div className="supplies">
        <main>
          <header>
            <div className="screen-title">Supplies & Equipment</div>
          </header>
          <div className="detailsContainer">
            <p className="med-kit nimbus-regular-font">
              Athletic trainers are instructed to bring their own med kit.
              <ToolTip
                id="medical-kit-icon"
                top="3px"
                bodyText="Medical kits can vary but often include first aid supplies, personal protective equipment (PPE), specialized medical equipment, and injury management tools."
              />
            </p>
            <p className="select-supplies-text gotham-bold-font">
              Select all supplies and equipment available at this location
            </p>
            <div className="equipment-grid">
              {Object.entries(groupedEquipments).map(([sectionName, equipments]) => {
                const isOpen = this.state.openSections[sectionName] || false;
                const item = {
                  title: sectionName,
                  open: isOpen,
                  content: (
                    <>
                      {equipments.map((equipment) => {
                        const name = equipment.label.split(' ').join('_').toLowerCase();
                        return (
                            <CustomCheckBox key={name}
                              id={name}
                              name={name}
                              checked={this.hasEquipment(equipment.label)}
                              onClick={this.toggleEquipment(equipment.label)}
                              className="equipment-item gotham-medium-font"
                            >
                              {equipment.label}
                            </CustomCheckBox>
                        );
                      })}
                    </>
                  ),
                };
                return (
                  <ExpandableSection
                    key={sectionName}
                    item={item}
                    handleClick={this.handleExpandableClick(sectionName)}
                  />
                );
              })}
              <ExpandableSection 
                key="Other"
                className="other-section"
                item={{
                  title: 'Other',
                  open: this.state.openSections['Other'] || false,
                  content: (
                    <div className="form-group other-supplies nimbus-regular-font">
                      <label htmlFor="other_equipments">
                        List other supplies or equipment available (separate by a comma). 
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        aria-label="Text input with dropdown button"
                        value={get(supplies, 'equipments[0]', '')}
                        id="other_equipments"
                        name="otherEquipments"
                        onClick={(e) => e.stopPropagation()}
                        onChange={this.onChangeOtherEquipments}
                      />
                    </div>
                  ),
                }}
                handleClick={this.handleExpandableClick('Other')}
              />
            </div>
          </div>
          <ActionBar
            editMode={this.props.editMode}
            backTo={this.computeBackTo()}
            currentStep="details/supplies"
            onSaveAndContinue={this.onSaveAndContinue}
          />
        </main>
        <ConfirmationModal
          isOpen={this.state.isModalOpen}
          toggle={this.toggle}
          title="No Supplies Selected"
          body="Please confirm no supplies & equipment are provided at this location."
          onSave={this.onSaveModal}
          cancelText="Go Back"
          onCancel={this.toggle}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const { post } = state;
  const { locationIdx } = post.navigation;
  const shiftLocation = post.locations[locationIdx];

  return {
    post,
    shiftLocation,
    locationIdx,
    authenticated: state.session.authenticated,
    user: state.session.currentUser,
  };
};

const mapDispatchToProps = (dispatch) => ({
  saveAsDraft: (post, callback) => dispatch(saveAsDraft({ post, callback, from: 'supplies' })),
  onSuppliesChange: (locationIndex, name, value) =>
    dispatch(suppliesFieldChange({ locationIndex, name, value })),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Supplies));
